import React from 'react';

import HeaderFooterShell from '@hydra/common/shell/HeaderFooterShell';
import { ErrorPage } from '@hydra/common/error';

const ErrorGeneric = ({ error }) => {
  return (
    <HeaderFooterShell>
      <ErrorPage error={error} />;
    </HeaderFooterShell>
  );
};

export default ErrorGeneric;
